// CODE AUTOGENERATED BY npm run updateapi
// IF YOU MODIFY THIS FILE, MAKE SURE TO ALSO MODIFY THE updateapi SCRIPT!
// OTHERWISE YOUR CHANGES MAY BE OVERWRITTEN!

import { Socket } from 'socket.io-client';
import * as dto from '../all.dto';

export class ServerApi {
  constructor(private socket: Socket) {}

  send(ev: string, data: {}) {
    console.log(`Sending ${ev} with ${JSON.stringify(data)}`);
    return this.socket.timeout(5000).emitWithAck(ev, data);
  }

  requestAchievementData(data: dto.RequestAchievementDataDto) {
    return this.send('requestAchievementData', data) as Promise<
      number | undefined
    >;
  }

  requestAchievementTrackerData(data: dto.RequestAchievementTrackerDataDto) {
    return this.send('requestAchievementTrackerData', data) as Promise<
      number | undefined
    >;
  }

  updateAchievementData(data: dto.UpdateAchievementDataDto) {
    return this.send('updateAchievementData', data) as Promise<
      string | undefined
    >;
  }

  requestBearItems(data: dto.RequestBearItemsDto) {
    return this.send('requestBearItems', data) as Promise<number | undefined>;
  }

  requestUserInventory(data: dto.RequestUserInventoryDto) {
    return this.send('requestUserInventory', data) as Promise<
      number | undefined
    >;
  }

  requestUserBearLoadout(data: dto.RequestUserBearLoadoutDto) {
    return this.send('requestUserBearLoadout', data) as Promise<
      number | undefined
    >;
  }

  purchaseBearItem(data: dto.PurchaseBearItemDto) {
    return this.send('purchaseBearItem', data) as Promise<boolean | undefined>;
  }

  equipBearItem(data: dto.EquipBearItemDto) {
    return this.send('equipBearItem', data) as Promise<boolean | undefined>;
  }

  requestAllBearItems(data: dto.RequestAllBearItemsDto) {
    return this.send('requestAllBearItems', data) as Promise<
      number | undefined
    >;
  }

  updateBearItemData(data: dto.UpdateBearItemDataDto) {
    return this.send('updateBearItemData', data) as Promise<string | undefined>;
  }

  requestCampusEvents(data: dto.RequestCampusEventsDto) {
    return this.send('requestCampusEvents', data) as Promise<
      number | undefined
    >;
  }

  requestCampusEventDetails(data: dto.RequestCampusEventDetailsDto) {
    return this.send('requestCampusEventDetails', data) as Promise<
      string | undefined
    >;
  }

  requestAllCampusEvents(data: dto.RequestCampusEventsDto) {
    return this.send('requestAllCampusEvents', data) as Promise<
      number | undefined
    >;
  }

  createCampusEvent(data: dto.UpsertCampusEventDto) {
    return this.send('createCampusEvent', data) as Promise<string | undefined>;
  }

  updateCampusEvent(data: dto.UpsertCampusEventDto) {
    return this.send('updateCampusEvent', data) as Promise<string | undefined>;
  }

  deleteCampusEvent(data: dto.DeleteCampusEventDto) {
    return this.send('deleteCampusEvent', data) as Promise<boolean | undefined>;
  }

  rsvpCampusEvent(data: dto.RsvpCampusEventDto) {
    return this.send('rsvpCampusEvent', data) as Promise<boolean | undefined>;
  }

  unRsvpCampusEvent(data: dto.UnRsvpCampusEventDto) {
    return this.send('unRsvpCampusEvent', data) as Promise<boolean | undefined>;
  }

  requestAvailableChallenges(data: dto.RequestAvailableChallengesDto) {
    return this.send('requestAvailableChallenges', data) as Promise<
      any | undefined
    >;
  }

  setCurrentChallenge(data: dto.SetCurrentChallengeDto) {
    return this.send('setCurrentChallenge', data) as Promise<any | undefined>;
  }

  requestChallengeData(data: dto.RequestChallengeDataDto) {
    return this.send('requestChallengeData', data) as Promise<
      number | undefined
    >;
  }

  completedChallenge(data: dto.CompletedChallengeDto) {
    return this.send('completedChallenge', data) as Promise<string | undefined>;
  }

  updateChallengeData(data: dto.UpdateChallengeDataDto) {
    return this.send('updateChallengeData', data) as Promise<
      string | undefined
    >;
  }

  checkInWithLocation(data: dto.LocationCheckInDto) {
    return this.send('checkInWithLocation', data) as Promise<
      boolean | undefined
    >;
  }

  checkInWithQrCode(data: dto.QrCodeCheckInDto) {
    return this.send('checkInWithQrCode', data) as Promise<boolean | undefined>;
  }

  requestEventData(data: dto.RequestEventDataDto) {
    return this.send('requestEventData', data) as Promise<number | undefined>;
  }

  requestFilteredEventIds(data: dto.RequestFilteredEventsDto) {
    return this.send('requestFilteredEventIds', data) as Promise<
      number | undefined
    >;
  }

  requestRecommendedEvents(data: dto.RequestRecommendedEventsDto) {
    return this.send('requestRecommendedEvents', data) as Promise<
      number | undefined
    >;
  }

  requestEventLeaderData(data: dto.RequestEventLeaderDataDto) {
    return this.send('requestEventLeaderData', data) as Promise<
      number | undefined
    >;
  }

  requestEventTrackerData(data: dto.RequestEventTrackerDataDto) {
    return this.send('requestEventTrackerData', data) as Promise<
      number | undefined
    >;
  }

  useEventTrackerHint(data: dto.UseEventTrackerHintDto) {
    return this.send('useEventTrackerHint', data) as Promise<
      boolean | undefined
    >;
  }

  updateEventData(data: dto.UpdateEventDataDto) {
    return this.send('updateEventData', data) as Promise<string | undefined>;
  }

  triggerEventSync(data: dto.TriggerEventSyncDto) {
    return this.send('triggerEventSync', data) as Promise<any | undefined>;
  }

  requestEventSyncStatus() {
    return this.send('requestEventSyncStatus', {}) as Promise<any | undefined>;
  }

  submitFeedback(data: dto.SubmitFeedbackDto) {
    return this.send('submitFeedback', data) as Promise<boolean | undefined>;
  }

  requestFeedbackData() {
    return this.send('requestFeedbackData', {}) as Promise<boolean | undefined>;
  }

  requestGroupData(data: dto.RequestGroupDataDto) {
    return this.send('requestGroupData', data) as Promise<boolean | undefined>;
  }

  joinGroup(data: dto.JoinGroupDto) {
    return this.send('joinGroup', data) as Promise<boolean | undefined>;
  }

  leaveGroup(data: dto.LeaveGroupDto) {
    return this.send('leaveGroup', data) as Promise<boolean | undefined>;
  }

  setCurrentEvent(data: dto.SetCurrentEventDto) {
    return this.send('setCurrentEvent', data) as Promise<boolean | undefined>;
  }

  updateGroupData(data: dto.UpdateGroupDataDto) {
    return this.send('updateGroupData', data) as Promise<boolean | undefined>;
  }

  sendGroupInvite(data: dto.SendGroupInviteDto) {
    return this.send('sendGroupInvite', data) as Promise<boolean | undefined>;
  }

  updateFcmToken(data: dto.UpdatePushTokenDto) {
    return this.send('updateFcmToken', data) as Promise<boolean | undefined>;
  }

  sendNotification(data: dto.SendNotificationDto) {
    return this.send('sendNotification', data) as Promise<any | undefined>;
  }

  removeFcmToken() {
    return this.send('removeFcmToken', {}) as Promise<boolean | undefined>;
  }

  requestOrganizationData(data: dto.RequestOrganizationDataDto) {
    return this.send('requestOrganizationData', data) as Promise<
      number | undefined
    >;
  }

  updateOrganizationData(data: dto.UpdateOrganizationDataDto) {
    return this.send('updateOrganizationData', data) as Promise<
      string | undefined
    >;
  }

  requestQuizQuestion(data: dto.RequestQuizQuestionDto) {
    return this.send('requestQuizQuestion', data) as Promise<
      boolean | undefined
    >;
  }

  shuffleQuizQuestion(data: dto.ShuffleQuizQuestionDto) {
    return this.send('shuffleQuizQuestion', data) as Promise<
      boolean | undefined
    >;
  }

  submitQuizAnswer(data: dto.SubmitQuizAnswerDto) {
    return this.send('submitQuizAnswer', data) as Promise<boolean | undefined>;
  }

  getQuizProgress(data: dto.RequestQuizQuestionDto) {
    return this.send('getQuizProgress', data) as Promise<boolean | undefined>;
  }

  requestQuizQuestions(data: dto.RequestQuizQuestionDto) {
    return this.send('requestQuizQuestions', data) as Promise<
      number | undefined
    >;
  }

  updateQuizQuestionData(data: dto.UpdateQuizQuestionDataDto) {
    return this.send('updateQuizQuestionData', data) as Promise<
      string | undefined
    >;
  }

  startChallengeTimer(data: dto.StartChallengeTimerDto) {
    return this.send('startChallengeTimer', data) as Promise<
      string | undefined
    >;
  }

  extendTimer(data: dto.ExtendTimerDto) {
    return this.send('extendTimer', data) as Promise<string | undefined>;
  }

  completeTimer(data: dto.TimerCompletedDto) {
    return this.send('completeTimer', data) as Promise<boolean | undefined>;
  }

  requestAllUserData(data: dto.RequestAllUserDataDto) {
    return this.send('requestAllUserData', data) as Promise<number | undefined>;
  }

  requestUserData(data: dto.RequestUserDataDto) {
    return this.send('requestUserData', data) as Promise<boolean | undefined>;
  }

  updateUserData(data: dto.UpdateUserDataDto) {
    return this.send('updateUserData', data) as Promise<boolean | undefined>;
  }

  setAuthToDevice(data: dto.SetAuthToDeviceDto) {
    return this.send('setAuthToDevice', data) as Promise<boolean | undefined>;
  }

  setAuthToOAuth(data: dto.SetAuthToOAuthDto) {
    return this.send('setAuthToOAuth', data) as Promise<boolean | undefined>;
  }

  banUser(data: dto.BanUserDto) {
    return this.send('banUser', data) as Promise<boolean | undefined>;
  }

  addManager(data: dto.AddManagerDto) {
    return this.send('addManager', data) as Promise<string | undefined>;
  }

  joinOrganization(data: dto.JoinOrganizationDto) {
    return this.send('joinOrganization', data) as Promise<boolean | undefined>;
  }

  completeOnboarding(data: dto.CompleteOnboardingDto) {
    return this.send('completeOnboarding', data) as Promise<
      boolean | undefined
    >;
  }

  resetOnboarding(data: dto.ResetOnboardingDto) {
    return this.send('resetOnboarding', data) as Promise<boolean | undefined>;
  }

  closeAccount(data: dto.CloseAccountDto) {
    return this.send('closeAccount', data) as Promise<boolean | undefined>;
  }

  onUpdateUserData(callback: (data: dto.UpdateUserDataDto) => void) {
    this.socket.removeAllListeners('updateUserData');
    this.socket.on('updateUserData', data => callback(data));
  }

  onUpdateErrorData(callback: (data: dto.UpdateErrorDto) => void) {
    this.socket.removeAllListeners('updateErrorData');
    this.socket.on('updateErrorData', data => callback(data));
  }

  onUpdateChallengeData(callback: (data: dto.UpdateChallengeDataDto) => void) {
    this.socket.removeAllListeners('updateChallengeData');
    this.socket.on('updateChallengeData', data => callback(data));
  }

  onUpdateAchievementData(
    callback: (data: dto.UpdateAchievementDataDto) => void,
  ) {
    this.socket.removeAllListeners('updateAchievementData');
    this.socket.on('updateAchievementData', data => callback(data));
  }

  onUpdateAchievementTrackerData(
    callback: (data: dto.AchievementTrackerDto) => void,
  ) {
    this.socket.removeAllListeners('updateAchievementTrackerData');
    this.socket.on('updateAchievementTrackerData', data => callback(data));
  }

  onUpdateEventTrackerData(callback: (data: dto.EventTrackerDto) => void) {
    this.socket.removeAllListeners('updateEventTrackerData');
    this.socket.on('updateEventTrackerData', data => callback(data));
  }

  onUpdateEventData(callback: (data: dto.UpdateEventDataDto) => void) {
    this.socket.removeAllListeners('updateEventData');
    this.socket.on('updateEventData', data => callback(data));
  }

  onUpdateLeaderData(callback: (data: dto.UpdateLeaderDataDto) => void) {
    this.socket.removeAllListeners('updateLeaderData');
    this.socket.on('updateLeaderData', data => callback(data));
  }

  onGroupInvitation(callback: (data: dto.GroupInviteDto) => void) {
    this.socket.removeAllListeners('groupInvitation');
    this.socket.on('groupInvitation', data => callback(data));
  }

  onUpdateGroupData(callback: (data: dto.UpdateGroupDataDto) => void) {
    this.socket.removeAllListeners('updateGroupData');
    this.socket.on('updateGroupData', data => callback(data));
  }

  onUpdateOrganizationData(
    callback: (data: dto.UpdateOrganizationDataDto) => void,
  ) {
    this.socket.removeAllListeners('updateOrganizationData');
    this.socket.on('updateOrganizationData', data => callback(data));
  }

  onUpdateLeaderPosition(
    callback: (data: dto.UpdateLeaderPositionDto) => void,
  ) {
    this.socket.removeAllListeners('updateLeaderPosition');
    this.socket.on('updateLeaderPosition', data => callback(data));
  }

  onUpdateBearItemsData(callback: (data: dto.UpdateBearItemsDataDto) => void) {
    this.socket.removeAllListeners('updateBearItemsData');
    this.socket.on('updateBearItemsData', data => callback(data));
  }

  onUpdateBearItemData(callback: (data: dto.UpdateBearItemDataDto) => void) {
    this.socket.removeAllListeners('updateBearItemData');
    this.socket.on('updateBearItemData', data => callback(data));
  }

  onUpdateUserInventoryData(
    callback: (data: dto.UpdateUserInventoryDataDto) => void,
  ) {
    this.socket.removeAllListeners('updateUserInventoryData');
    this.socket.on('updateUserInventoryData', data => callback(data));
  }

  onUpdateUserBearLoadoutData(
    callback: (data: dto.UpdateUserBearLoadoutDataDto) => void,
  ) {
    this.socket.removeAllListeners('updateUserBearLoadoutData');
    this.socket.on('updateUserBearLoadoutData', data => callback(data));
  }

  onUpdatePurchaseResult(
    callback: (data: dto.UpdatePurchaseResultDto) => void,
  ) {
    this.socket.removeAllListeners('updatePurchaseResult');
    this.socket.on('updatePurchaseResult', data => callback(data));
  }

  onTimerStarted(callback: (data: dto.TimerStartedDto) => void) {
    this.socket.removeAllListeners('timerStarted');
    this.socket.on('timerStarted', data => callback(data));
  }

  onTimerExtended(callback: (data: dto.TimerExtendedDto) => void) {
    this.socket.removeAllListeners('timerExtended');
    this.socket.on('timerExtended', data => callback(data));
  }

  onTimerCompleted(callback: (data: dto.TimerCompletedDto) => void) {
    this.socket.removeAllListeners('timerCompleted');
    this.socket.on('timerCompleted', data => callback(data));
  }

  onTimerWarning(callback: (data: dto.TimerWarningDto) => void) {
    this.socket.removeAllListeners('timerWarning');
    this.socket.on('timerWarning', data => callback(data));
  }

  onChallengeFailed(callback: (data: dto.ChallengeFailedDto) => void) {
    this.socket.removeAllListeners('challengeFailed');
    this.socket.on('challengeFailed', data => callback(data));
  }

  onUpdateQuizQuestionData(
    callback: (data: dto.UpdateQuizQuestionDataDto) => void,
  ) {
    this.socket.removeAllListeners('updateQuizQuestionData');
    this.socket.on('updateQuizQuestionData', data => callback(data));
  }

  onQuizQuestion(callback: (data: dto.QuizQuestionDto) => void) {
    this.socket.removeAllListeners('quizQuestion');
    this.socket.on('quizQuestion', data => callback(data));
  }

  onQuizResult(callback: (data: dto.QuizResultDto) => void) {
    this.socket.removeAllListeners('quizResult');
    this.socket.on('quizResult', data => callback(data));
  }

  onQuizError(callback: (data: dto.QuizErrorDto) => void) {
    this.socket.removeAllListeners('quizError');
    this.socket.on('quizError', data => callback(data));
  }

  onQuizProgress(callback: (data: dto.QuizProgressDto) => void) {
    this.socket.removeAllListeners('quizProgress');
    this.socket.on('quizProgress', data => callback(data));
  }

  onUpdateFeedbackData(callback: (data: dto.UpdateFeedbackDataDto) => void) {
    this.socket.removeAllListeners('updateFeedbackData');
    this.socket.on('updateFeedbackData', data => callback(data));
  }

  onUpdateCampusEventData(
    callback: (data: dto.UpdateCampusEventDataDto) => void,
  ) {
    this.socket.removeAllListeners('updateCampusEventData');
    this.socket.on('updateCampusEventData', data => callback(data));
  }

  onCampusEventList(callback: (data: dto.CampusEventListResponseDto) => void) {
    this.socket.removeAllListeners('campusEventList');
    this.socket.on('campusEventList', data => callback(data));
  }
}
